import {ItemsTileItem} from './ItemsTileItem/ItemsTileItem';

export class ItemsTile {

  //public static readonly SIZE = 4096;
  //public static readonly SIZE = 1024;
  public static readonly SIZE = 512;
  //public static readonly SIZE = 256;

  public static readonly DRAW_ZOOM = 16;
  public static readonly ZOOM = ItemsTile.DRAW_ZOOM;
  //public static readonly ZOOM = ItemsTile.DRAW_ZOOM - (Math.log2(ItemsTile.SIZE) - 8 /* Math.log2(256) */);

  private static tilingScheme = undefined;

  private id = undefined;

  private x = undefined;
  private y = undefined;

  private rectangle = undefined;

  //private canvas?: HTMLCanvasElement = undefined;

  //private context?: CanvasRenderingContext2D = undefined;

  private items = new Map<string, ItemsTileItem>();

  constructor(x, y, rectangle) {
    this.x = x;
    this.y = y;
    this.rectangle = rectangle;

    //this.canvas = document.createElement('canvas');
    //this.canvas.width = ItemsTile.SIZE;
    //this.canvas.height = ItemsTile.SIZE;

    //this.context = this.canvas.getContext('2d');
  }

  private static getTilingScheme() {
    if (ItemsTile.tilingScheme === undefined) {
      ItemsTile.tilingScheme = new Cesium.WebMercatorTilingScheme();
    }
    return ItemsTile.tilingScheme;
  }

  public static generateKey(x, y) {
    return JSON.stringify({x, y});
  }

  public static xyFromDegrees(lat, lng, height = 0) {
    const xy = ItemsTile.getTilingScheme().positionToTileXY(
      Cesium.Cartographic.fromDegrees(lng, lat, height),
      ItemsTile.ZOOM
    );
    return xy;
  }

  public static fromDegrees(lat, lng, height = 0) {
    const xy = ItemsTile.xyFromDegrees(lat, lng, height);
    return ItemsTile.fromXY(xy.x, xy.y);
  }

  public static calculateRectangle(x, y) {
    return ItemsTile.getTilingScheme().tileXYToRectangle(x, y, ItemsTile.ZOOM);
  }

  public static fromXY(x, y) {
    const rectangle = ItemsTile.calculateRectangle(x, y);

    const tile = new ItemsTile(x, y, rectangle);
    //console.log('[ITEMS CANVAS] createFromDegrees', tile);

    return tile;
  }

  public latLngToTileXY(latLng) {
    // METHOD 1 A
    const xy = this.latLangToPx(latLng);
    // console.log('[ITEMS CANVAS] Method I A: x , y, tileX, tileY, dx, dy',
    //   xy.x, xy.y, this.x * ItemsTile.SIZE, this.y * ItemsTile.SIZE,
    //   xy.x - this.x * ItemsTile.SIZE, xy.y - this.y * ItemsTile.SIZE
    // );
    return { x: xy.x - this.x * ItemsTile.SIZE, y: xy.y - this.y * ItemsTile.SIZE };

    // METHOD 1 B (results tha same)
    // const nw = this.latLangToPx({lat: Cesium.Math.toDegrees(this.rectangle.north), lng: Cesium.Math.toDegrees(this.rectangle.west)});
    // const se = this.latLangToPx({lat: Cesium.Math.toDegrees(this.rectangle.south), lng: Cesium.Math.toDegrees(this.rectangle.east) });
    // console.log('[ITEMS CANVAS] Method I B: rectangle', xy.x, xy.y, nw, se, xy.x - nw.x, xy.y - nw.y, xy.x - se.x, xy.y - se.y);
    // return { x: xy.x - nw.x, y: xy.y - nw.y };
  }

  public latLangToPx(latLng) {
    let siny = Math.sin((latLng.lat * Math.PI) / 180);

    // Truncating to 0.9999 effectively limits latitude to 89.189. This is
    // about a third of a tile past the edge of the world tile.
    siny = Math.min(Math.max(siny, -0.9999), 0.9999);

    const y = Math.floor(ItemsTile.SIZE * (0.5 - Math.log((1 + siny) / (1 - siny)) / (4 * Math.PI)) * (1 << ItemsTile.ZOOM));
    const x = Math.floor(ItemsTile.SIZE * (0.5 + latLng.lng / 360) * (1 << ItemsTile.ZOOM));

    return {x, y};
  }

  public getItems() {
    return this.items.values();
  }

  public hasItem(id: string): boolean {
    return this.items.has(id);
  }

  public addItem(item: ItemsTileItem) {
    this.items.set(item.getId(), item);
  }

  public deleteItem(id: string) {
    this.items.delete(id);
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;
  }

  public getKey() {
    return ItemsTile.generateKey(this.x, this.y);
  }

  public getRectangle() {
    return this.rectangle;
  }

  // public getCanvas() {
  //   return this.canvas;
  // }
  //
  // public getContext(): CanvasRenderingContext2D {
  //   //return this.context;
  //   return this.canvas.getContext('2d');
  // }

}
